export const MAIN_NAV = [
  { to: "/radio", label: "Radio", key: "radio" },
  { to: "/agenda", label: "Agenda", key: "agenda" },
  { to: "/news", label: "Magazine", key: "magazine" },
];

export const LIEUX = [
  { to: "/lieux/disquaires", label: "Disquaires", key: "disquaires" },
  { to: "/lieux/salles", label: "Salles de concert", key: "salles" },
  { to: "/lieux/bars", label: "Bars / Restaurants", key: "bars" },
  { to: "/lieux/clubs", label: "Clubs", key: "clubs" },
  { to: "/lieux/cafes", label: "Cafés", key: "cafes" },
  { to: "/lieux/galeries", label: "Galeries", key: "galeries" },
  { to: "/lieux/librairies", label: "Librairies", key: "librairies" },
];

export const ABOUT = [
  { to: "/mentions-legales", label: "Mentions légales", key: "mentions" },
  { to: "/conditions-generales", label: "Conditions générales", key: "cgu" },
];

export const MORE_GROUPS = [
  {
    title: "Côté radio",
    key: "radio",
    links: [
      { to: "/radio#titres-diffuses", label: "Titres diffusés", key: "titres-diffuses" },
      { to: "/radio#podcasts", label: "Podcasts", key: "podcasts" },
      { to: "/radio#favoris", label: "Mes favoris", key: "favoris" },
      { to: "/arrivages", label: "Arrivages", key: "arrivages" },
    ],
  },
  {
    title: "Découvrir",
    key: "decouvrir",
    links: [{ to: "/artistes", label: "Artistes", key: "artistes" }, { to: "/lieux", label: "Carte des lieux", key: "carte-lieux" }, ...LIEUX],
  },
  {
    title: "LGTDZ",
    key: "lgtdz",
    links: [
      { to: "/soutenir", label: "Soutenir", key: "soutenir" },
      { to: "/contact", label: "Contact", key: "contact" },
    ],
  },
];
